import rs from "./custom-event-data.js";
import ls from "./custom-event-property-data.js";
import is from "./filter-set.js";
import ui from "./in-app-message-click-data.js";
import ns from "./purchase-data.js";
import us from "./purchase-property-data.js";
import ur from "./push-click-data.js";
import ot from "./trigger-events.js";
import { logger as N } from "../../../shared-lib/index.js";
import { getErrorMessage as si } from "../../util/error-utils.js";
export default class ri {
  constructor(e, t) {
    (this.type = e), (this.data = t), (this.type = e), (this.data = t);
  }
  kc(e, t) {
    return ri._c[this.type] === e && (null == this.data || this.data.xc(t));
  }
  static sf(e, t) {
    let r = null;
    try {
      r = window.atob(e);
    } catch (t) {
      return N.info("Failed to unencode analytics id " + e + ": " + si(t)), !1;
    }
    return t === r.split("_")[0];
  }
  static fromJson(e) {
    const t = e.type;
    let r = null;
    switch (t) {
      case ri.qr.OPEN:
      case ri.qr.vs:
        break;
      case ri.qr.Rr:
        r = ns.fromJson(e.data);
        break;
      case ri.qr.Ec:
        r = us.fromJson(e.data);
        break;
      case ri.qr.kr:
        r = ur.fromJson(e.data);
        break;
      case ri.qr.Ee:
        r = rs.fromJson(e.data);
        break;
      case ri.qr.jc:
        r = ls.fromJson(e.data);
        break;
      case ri.qr.Qr:
        r = ui.fromJson(e.data);
    }
    return new ri(t, r);
  }
  bt() {
    return { t: this.type, d: this.data ? this.data.bt() : null };
  }
  static zn(e) {
    let t,
      r = null;
    switch (e.t) {
      case ri.qr.OPEN:
      case ri.qr.vs:
        break;
      case ri.qr.Rr:
        r = new ns(e.d);
        break;
      case ri.qr.Ec:
        (t = e.d || {}), (r = new us(t.id, is.zn(t.pf || [])));
        break;
      case ri.qr.kr:
        r = new ur(e.d);
        break;
      case ri.qr.Ee:
        r = new rs(e.d);
        break;
      case ri.qr.jc:
        (t = e.d || {}), (r = new ls(t.e, is.zn(t.pf || [])));
        break;
      case ri.qr.Qr:
        r = new ui(e.d);
    }
    return new ri(e.t, r);
  }
}
(ri.qr = {
  OPEN: "open",
  Rr: "purchase",
  Ec: "purchase_property",
  kr: "push_click",
  Ee: "custom_event",
  jc: "custom_event_property",
  Qr: "iam_click",
  vs: "test",
}),
  (ri._c = {}),
  (ri._c[ri.qr.OPEN] = ot.OPEN),
  (ri._c[ri.qr.Rr] = ot.Rr),
  (ri._c[ri.qr.Ec] = ot.Rr),
  (ri._c[ri.qr.kr] = ot.kr),
  (ri._c[ri.qr.Ee] = ot.Ee),
  (ri._c[ri.qr.jc] = ot.Ee),
  (ri._c[ri.qr.Qr] = ot.Qr),
  (ri._c[ri.qr.vs] = ot.vs);
